export const CLOSED_MARKETS: {
  exacts: Record<string, boolean>;
  parts: string[];
  regExps: RegExp[];
} = {
  exacts: {
    MatchRaceTo: true,
    OutcomeAndTotal: true,
    HalfTimeFullTime: true,
    OutcomeOrTotal: true,
    OutcomeOrScore: true,
    Total3: true,
    TeamToScore: true,
    SetTotalGames: true,
    GameWinner: true,
    MatchWinningMargin: true,
    QuarterWinningMargin: true,
    SetWinningMargin: true,
    FirstHalfVsSecondHalfHandicap: true,
    PlayerToScore2OrMore: true,
    PlayerScoresBothHalves: true,
    ToScoreInFirst10Mins: true,
    CornersRaceTo: true,
    ChanceMix: true,
    DoubleChanceCombo: true,
    PlayerGetsCard: true,
    ToBeSentOff: true,
    EachTeamToScoreUnder: true,
    '1stSet-Match': true,
    'Hat-trick': true,
    'HalfTime/FullTimeScore': true
  },
  parts: [
    'OutcomeAndTotal',
    'Goalscorer',
    'CorrectScore',
    'GameWinningMarginTeam',
    'HalfTime/FullTimeScore',
    'HalfTime/Full-timeandTotalGoals'
  ],
  regExps: [/^(GamePoint)\d(Winner)$/, /^(RaceTo)\d(Games)$/]
};
